export const sellerWasConnectedOnOtherAccount =
  'A seller account that was connected to an older account cannot be used in an account with holiday special subscription.';
